import React, { useState, useEffect } from 'react'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import dayjs from "dayjs";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { Autocomplete, IconButton, MenuItem } from '@mui/material';
import { Select, InputLabel, FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useNavigate } from 'react-router-dom';
import { getAllCustomersAuto } from '../../../lib/api-customer';
import { getUltrasonicById, updateUltrasonic, createUltrasonic, getAutoCertificateNo, deleteUltrasonicDescription, getPrint, getUltrasonicPDF } from '../../../lib/api-ultrasonic'
import DeleteIcon from '@mui/icons-material/Delete';
import { getAllEquipment, getAllStandards } from '../../../lib/api-ut';
import { DataGrid } from '@mui/x-data-grid';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { APP_BASE_PATH } from "../../../lib/api-base-paths";
import CustomSnackbar from "../../../components/common/CustomSnackbar";
import { layoutPrintFormFields } from "../../../utils/printFieldLayout";
import { getAllProb } from '../../../lib/api-probe';
import { getUnpaidBillsByCustomer } from '../../../lib/api-bill';


const CreateUltrasonic = ({ ultraId, isEdit }) => {
  const [cust, setCust] = useState([]);
  const [stand, setStand] = useState([]);
  const [stand1, setStand1] = useState([]);
  const [equip, setEquip] = useState([]);
  const [prob, setProb] = useState([]);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [color, setColor] = useState("")
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [certificate_num, setCertificate_num] = useState(null);
  const [loading, setLoading] = useState(false);
  const [latestId, setLatestId] = useState(false)
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [unpaidBills, setUnpaidBills] = useState([]);
  const [unpaidDialogOpen, setUnpaidDialogOpen] = useState(false);
  const thStyle = { padding: '8px 12px', textAlign: 'left', fontWeight: 600 };
  const tdStyle = { padding: '7px 12px', borderBottom: '1px solid #e0e0e0' };
  const handlePDFModalClose = () => {
    setPdfData(null)
    setOpenPDFModal(false)
  };
  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/Ultrasonic')
  }

  const [rows, setRows] = useState([]);
  const [formikValues, setFormikValues] = useState({
    Description: '',
    Qty: '',
    Accepted: '',
    Grade: '',
    Rejected: '',
    Remarks: '',
    customRemarks: ''
  });
  const [idCounter, setIdCounter] = useState(1);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormikValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleAddRow = () => {

    if (!formikValues.Description || !formikValues.Qty || !formikValues.Accepted || !formikValues.Grade || !formikValues.Rejected || !formikValues.Remarks) {
      alert("Please fill in all required fields.");
      return;
    }

    const newRow = { id: idCounter, srNo: idCounter, ...formikValues };
    setIdCounter(idCounter + 1);

    if (rows.length > 0) {
      const maxSrNo = Math.max(...rows.map(row => row.srNo));
      newRow.srNo = maxSrNo + 1;
    } else {
      newRow.srNo = 1;
    }

    newRow.id = newRow.srNo;

    newRow.Remarks = formikValues.Remarks === 'Other' ? formikValues.customRemarks : formikValues.Remarks;

    setRows(prevRows => [...prevRows, newRow]);

    setFormikValues({
      Description: '',
      Qty: '',
      Accepted: '',
      Grade: '',
      Rejected: '',
      Remarks: '',
      customRemarks: ''
    });
  };




  const handleDelete = (id) => {
    deleteUltrasonicDescription(id)
      .then(response => {
        console.log(response.data);
        setRows(prevRows => prevRows.filter(row => row.id !== id));
      })
      .catch(error => {
        console.error('Error deleting row:', error);
      });
  };


  const initialValues = {
    Certificate_No: '',
    Cert_Date: new Date(),
    Cust_Name: { value: '', label: '' },
    Referance_Id: '',
    Exam_Stage: '',
    Acceptance_Std: '',
    Technique: '',
    Equipment: '',
    Standard: '',
    Range1: '',
    Gain: '',
    Techniquel: '',
    Probes_Use: '',
    Calibration_Block: '',
    Couplnat: '',
    Location: '',
    Witness_By: '',
    technician: '',
    designation: 'ASNT LEVEL II - UT.MT.PT',
    Scope_Exam: '',
    Surface_Condition: '',
    Surface_Temperature: '',
    Damping: '',
    Reject: '',
    Procedure_No: '',
    Angle: '',
    Size_Sr_No: '',
    Machine_Sr_No: '',
    Search_Unit_Cable: '',
    Calibration_Date: null,
    Calibration_Due_Date: null,
    FBH_Details: '',
    Cable_Type: '',
    Reference_dB: '',
    Scanning_dB: '',
    Scanning_Speed: '',
    Post_Cleaning: '',
  }

  const columns = [
    { field: 'srNo', headerName: 'Sr.No.', flex: 1 },
    { field: 'Description', headerName: 'Part Description', flex: 1 },
    { field: 'Qty', headerName: 'Qty', flex: 1 },
    { field: 'Accepted', headerName: 'Accepted', flex: 1 },
    { field: 'Grade', headerName: 'Grade', flex: 1 },
    { field: 'Rejected', headerName: 'Rejected', flex: 1 },
    { field: 'Remarks', headerName: 'Remarks', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <div>
          <IconButton onClick={() => handleDelete(params.row.id)}>
            <DeleteIcon sx={{ color: 'red' }} />
          </IconButton>
        </div>

      ),
    },
  ];


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllCustomersAuto();
        setCust(() => {
          const customerOp = response.map((row) => { return { value: row.Cust_Id, label: row.Cust_Name } });
          return customerOp;
        });
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchData();
  }, [])


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllEquipment();
        const EquipmentOp = response.map((row) => { return { value: row.Equipment_Id, label: row.Equipment_Nm } });
        setEquip(EquipmentOp);
      } catch (error) {
        console.error("Error fetching Equipment:", error);
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllProb();
        const ProbOp = response.map((row) => { return { value: row.Prob_Id, label: row.Prob_Nm } });
        setProb(ProbOp);
      } catch (error) {
        console.error("Error fetching Prob:", error);
      }
    };
    fetchData();
  }, [])


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllStandards();
        const Acceptance_StdOp = response.map((row) => { return { value: row.Standard_Id, label: row.Acceptance_Std } });
        setStand(Acceptance_StdOp);
        setStand1(Acceptance_StdOp);

      } catch (error) {
        console.error("Error fetching Acceptance_Std:", error);
      }
    };
    fetchData();
  }, [])


  useEffect(() => {
    const fetchCertificateNo = async () => {
      try {
        const getCertificateNo = await getAutoCertificateNo();
        const maxNumber = getCertificateNo.data.nextCertificateNo;
        formik.setFieldValue('Certificate_No', maxNumber);
        setCertificate_num(maxNumber);
      } catch (error) {

      }
    }
    fetchCertificateNo();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const getUltrasonicData = await getUltrasonicById(ultraId);
        setLatestId(true);
        const UltrasonicData = getUltrasonicData.data.ultrasonic;



        const parseDate = (dateString) => {
          if (dateString) {
            const parts = dateString.split('/');
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          return null;
        }
        const EquipNew = equip.find((item) => item.value == UltrasonicData.Equipment);
        const StandNew = stand.find((item) => item.value == UltrasonicData.Acceptance_Std);
        const StandNew1 = stand1.find((item) => item.value == UltrasonicData.Standard);
        const ProbNew = prob.find((item) => item.value == UltrasonicData.Probes_Use);
        const CustNew = cust.filter((item) => item.value == UltrasonicData.Cust_Name)[0];
        const sortedData = {
          Cert_Date: parseDate(UltrasonicData.Cert_Date),
          Cust_Name: CustNew,
          Certificate_No: UltrasonicData.Certificate_No,
          Referance_Id: UltrasonicData.Referance_Id,
          Exam_Stage: UltrasonicData.Exam_Stage,
          Acceptance_Std: StandNew?.label || UltrasonicData.Acceptance_Std || '',
          Technique: UltrasonicData.Technique,
          Equipment: EquipNew?.label || UltrasonicData.Equipment || '',
          Standard: StandNew1?.label || UltrasonicData.Standard || '',
          Range1: UltrasonicData.Range1,
          Gain: UltrasonicData.Gain,
          Techniquel: UltrasonicData.Techniquel,
          Probes_Use: ProbNew?.label || UltrasonicData.Probes_Use || '',
          Calibration_Block: UltrasonicData.Calibration_Block,
          Couplnat: UltrasonicData.Couplnat,
          Location: UltrasonicData.Location,
          Witness_By: UltrasonicData.Witness_By,
          technician: UltrasonicData.technician,
          designation: UltrasonicData.designation,
          Scope_Exam: UltrasonicData.Scope_Exam || '',
          Surface_Condition: UltrasonicData.Surface_Condition || '',
          Surface_Temperature: UltrasonicData.Surface_Temperature || '',
          Damping: UltrasonicData.Damping || '',
          Reject: UltrasonicData.Reject || '',
          Procedure_No: UltrasonicData.Procedure_No || '',
          Angle: UltrasonicData.Angle || '',
          Size_Sr_No: UltrasonicData.Size_Sr_No || '',
          Machine_Sr_No: UltrasonicData.Machine_Sr_No || '',
          Search_Unit_Cable: UltrasonicData.Search_Unit_Cable || '',
          Calibration_Date: UltrasonicData.Calibration_Date
            ? UltrasonicData.Calibration_Date.toString().split('T')[0]
            : null,
          Calibration_Due_Date: UltrasonicData.Calibration_Due_Date
            ? UltrasonicData.Calibration_Due_Date.toString().split('T')[0]
            : null, FBH_Details: UltrasonicData.FBH_Details || '',
          Cable_Type: UltrasonicData.Cable_Type || '',
          Reference_dB: UltrasonicData.Reference_dB || '',
          Scanning_dB: UltrasonicData.Scanning_dB || '',
          Scanning_Speed: UltrasonicData.Scanning_Speed || '',
          Post_Cleaning: UltrasonicData.Post_Cleaning || ''

        };
        formik.setValues(sortedData);

        const sortedRows = getUltrasonicData.data.rows.map((row, index) => ({
          id: row.id,
          srNo: index + 1,
          ...row
        }));
        setRows(sortedRows);
        setLoading(false);

      } catch (error) {
        console.log("Error in Fetching Ultrasonic Data", error);
      } finally {
        setLoading(false);
      }
    };
    if (isEdit) {
      fetchData();
    }
  }, [isEdit, ultraId, cust, equip, stand, stand1, prob]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      Cert_Date: Yup.date().required(),
      Certificate_No: Yup.number().required(),
      Cust_Name: Yup.object().notRequired(),
      Referance_Id: Yup.string().required(),
      Exam_Stage: Yup.string().required(),
      Acceptance_Std: Yup.string().required(),
      Technique: Yup.string().notRequired(),
      Standard: Yup.string().required(),
      Equipment: Yup.string().required(),
      Range1: Yup.string().required(),
      Gain: Yup.string().required(),
      Techniquel: Yup.string().required(),
      Probes_Use: Yup.string().notRequired(),
      Calibration_Block: Yup.string().required(),
      Couplnat: Yup.string().required(),
      Location: Yup.string().required(),
      Witness_By: Yup.string().required(),
      technician: Yup.string().required(),
      designation: Yup.string().required(),
      Scope_Exam: Yup.string().notRequired(),
      Surface_Condition: Yup.string().notRequired(),
      Surface_Temperature: Yup.string().notRequired(),
      Damping: Yup.string().notRequired(),
      Reject: Yup.string().notRequired(),
      Procedure_No: Yup.string().notRequired(),
      Angle: Yup.string().notRequired(),
      Size_Sr_No: Yup.string().notRequired(),
      Machine_Sr_No: Yup.string().notRequired(),
      Search_Unit_Cable: Yup.string().notRequired(),
      Calibration_Date: Yup.date().nullable().notRequired(),
      Calibration_Due_Date: Yup.date().nullable().notRequired(),
      FBH_Details: Yup.string().notRequired(),
      Cable_Type: Yup.string().notRequired(),
      Reference_dB: Yup.string().notRequired(),
      Scanning_dB: Yup.string().notRequired(),
      Scanning_Speed: Yup.string().notRequired(),
      Post_Cleaning: Yup.string().notRequired(),

    }),
    onSubmit: async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
      try {
        setLoading(true);
        let response = {};

        values.rows = rows;


        if (isEdit) {
          response = await updateUltrasonic(ultraId, values);
          setConfirmationMessage("Ultrasonic Updated successfully");
          setIsConfirmationOpen(true);
          setColor('green')
        } else {
          response = await createUltrasonic(values);
          if (response.status == 200) {
            setConfirmationMessage(response.data);
            setIsConfirmationOpen(true);
            setColor('green')
            setLatestId(true);
            resetForm();

            setRows([]);
          }
          else {
            setConfirmationMessage("Somthing Went Wrong!");
            setIsConfirmationOpen(true);
            setColor('error')
          }
        }
      } catch (error) {
        setStatus({ success: false });
        setErrors({ submit: error.response.data.message });
        setSubmitting(false);
      } finally {
        setLoading(false);
      }
    }

  });

  const ultrasonicPrintPairs = [
    { left: { name: 'Exam_Stage', label: 'Examination Stage' }, right: { name: 'Surface_Condition', label: 'Surface Condition' } },
    { left: { name: 'Scope_Exam', label: 'Scope of Examination' }, right: { name: 'Surface_Temperature', label: 'Surface Temperature' } },
    { left: { name: 'Location', label: 'Location' }, right: { name: 'Range1', label: 'Range' } },
    { left: { name: 'Acceptance_Std', label: 'Acceptance Standard' }, right: { name: 'Damping', label: 'Damping' } },
    { left: { name: 'Standard', label: 'Specification' }, right: { name: 'Reject', label: 'Reject' } },
    { left: { name: 'Procedure_No', label: 'Procedure No' }, right: { name: 'Probes_Use', label: 'Probes' } },
    { left: { name: 'Techniquel', label: 'UT Technique' }, right: { name: 'Angle', label: 'Angle' } },
    { left: { name: 'Equipment', label: 'Ultrasonic Machine Type' }, right: { name: 'Size_Sr_No', label: 'Size and Sr. No' } },
    { left: { name: 'Machine_Sr_No', label: 'Machine Sr. No' }, right: { name: 'Search_Unit_Cable', label: 'Search Unit Cable' } },
    { left: { name: 'Calibration_Date', label: 'Calibration Date', type: 'date' }, right: { name: 'Reference_dB', label: 'Reference dB' } },
    { left: { name: 'Calibration_Due_Date', label: 'Calibration Due Date', type: 'date' }, right: { name: 'Scanning_dB', label: 'Scanning dB' } },
    { left: { name: 'Calibration_Block', label: 'Calibration Block Ref' }, right: { name: 'Scanning_Speed', label: 'Scanning Speed' } },
    { left: { name: 'FBH_Details', label: 'FBH/SDH/Notch Details' }, right: { name: 'Couplnat', label: 'Couplant' } },
    // { left: { name: 'Cable_Type', label: 'Cable Type' }, right: { name: 'Post_Cleaning', label: 'Post Cleaning Done' } },
  ];

  const renderUltrasonicPrintField = (field) => {
    const key = field.reactKey || field.name;
    if (field.type === 'date') {
      return (
        <LocalizationProvider key={key} dateAdapter={AdapterDayjs}>
          <DatePicker
            label={field.label}
            format="DD/MM/YYYY"
            value={formik.values[field.name] ? dayjs(formik.values[field.name]) : null}
            onChange={(date) => formik.setFieldValue(field.name, date ? dayjs(date).format('YYYY-MM-DD') : null)}
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                onBlur: formik.handleBlur,
                error: formik.errors[field.name] && formik.touched[field.name],
                helperText: formik.touched[field.name] ? formik.errors[field.name] : '',
              },
            }}
          />
        </LocalizationProvider>
      );
    }
    return (
      <TextField
        key={key}
        fullWidth
        label={field.label}
        name={field.name}
        variant="outlined"
        value={formik.values[field.name] ?? ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors[field.name] && formik.touched[field.name]}
        helperText={formik.touched[field.name] ? formik.errors[field.name] : ''}
      />
    );
  };

  const handlep = () => {
    if (ultraId) {
      handlePrintforedit()
    } else {
      handlePrint()
    }
  }

  const handlePrintforedit = async () => {
    try {
      setLoading(true);
      const getPDF = await getUltrasonicPDF(ultraId);
      setOpenPDFModal(true);
      const filepath = getPDF.data.returnpath
      setPdfData(filepath);

    } catch (error) {
      console.error("Error while printing:", error);
    } finally {
      setLoading(false);

    }
  }
  const handlePrint = async () => {

    try {
      setLoading(true)
      const response = await getPrint();

      setOpenPDFModal(true);
      const filepath = response.returnpath

      setPdfData(filepath);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false)
    }

  }





  return (

    <div>
      {loading && <LoadingSpinner />}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: "0.5rem" }}>
          <FormControl style={{ width: "180px" }}><LocalizationProvider dateAdapter={AdapterDayjs}> <DatePicker name="Cert_Date" format="DD/MM/YYYY" label="Date" errors={formik.errors}
            value={formik.values.Cert_Date ? dayjs(formik.values.Cert_Date) : null}
            // onChange={(date) => {formik.setFieldValue('Cert_Date', date);}}
            onChange={(date) => {
              formik.setFieldValue(
                "Cert_Date",
                date ? dayjs(date).format('YYYY-MM-DD') : dayjs(formik.values.assignedDate).format('YYYY-MM-DD') || null
              );
            }} />  </LocalizationProvider></FormControl>
          <TextField style={{ width: "37.5vw" }} id="outlined-basic" label="Certificate No." name='Certificate_No' variant="outlined" error={formik.errors.Certificate_No && formik.touched.Certificate_No}
            helperText={formik.touched.Certificate_No ? formik.errors.Certificate_No : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Certificate_No} />
        </div>
        <div>
          <Autocomplete
            options={cust}
            getOptionLabel={(option) => option.label}
            onChange={async (event, value) => {
              formik.setFieldValue('Cust_Name', value || null);
              if (value) {
                try {
                  const res = await getUnpaidBillsByCustomer(value.value);
                  if (res.data && res.data.length > 0) {
                    setUnpaidBills(res.data);
                    setUnpaidDialogOpen(true);
                  }
                } catch (err) {
                  console.error('Error checking unpaid bills:', err);
                }
              }
            }}
            value={formik.values.Cust_Name}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: "50vw" }}
                label="Customer Name"
                variant="outlined"
                name="Cust_Name"
                error={formik.errors.Cust_Name && formik.touched.Cust_Name}
                helperText={formik.touched.Cust_Name ? formik.errors.Cust_Name : ''}
                onBlur={formik.handleBlur}
              />
            )}
          />

        </div>
        <div>
          <TextField style={{ width: "50vw" }} id="outlined-basic" label="Reference" name='Referance_Id' variant="outlined" error={formik.errors.Referance_Id && formik.touched.Referance_Id}
            helperText={formik.touched.Referance_Id ? formik.errors.Referance_Id : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Referance_Id} />

        </div>

        <div >
          <div>
            <div style={{ display: 'flex', alignItems: 'center', columnGap: '1%' }}>



              <TextField
                id="outlined-basic"
                label="Part Description"
                name="Description"
                variant="outlined"
                style={{ width: '10vw' }}
                onChange={handleChange}
                value={formikValues.Description}
              />

              <TextField
                id="outlined-basic"
                label="Qty"
                name="Qty"
                variant="outlined"
                style={{ width: '10vw' }}
                onChange={handleChange}
                value={formikValues.Qty}
              />

              <TextField
                id="outlined-basic"
                label="Accepted"
                name="Accepted"
                variant="outlined"
                style={{ width: '10vw' }}
                onChange={handleChange}
                value={formikValues.Accepted}
              />

              <TextField
                id="outlined-basic"
                label="Grade"
                name="Grade"
                variant="outlined"
                style={{ width: '10vw' }}
                onChange={handleChange}
                value={formikValues.Grade}
              />

              <TextField
                id="outlined-basic"
                label="Rejected"
                name="Rejected"
                variant="outlined"
                style={{ width: '10vw' }}
                onChange={handleChange}
                value={formikValues.Rejected}
              />

              <FormControl>
                <InputLabel id="remarks-label">Remarks</InputLabel>
                <Select
                  labelId="remarks-label"
                  value={formikValues.Remarks}
                  onChange={handleChange}
                  label="Remarks"
                  placeholder="Remarks"
                  name="Remarks"
                  style={{ width: '10vw' }}
                >
                  <MenuItem value="No recordable Indication observed- Hence Accepted.">No recordable Indication observed- Hence Accepted.</MenuItem>
                  <MenuItem value="Recordable indication observed hence not accepted.">Recordable indication observed hence not accepted.</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                  {formikValues.Remarks !== 'No recordable Indication observed- Hence Accepted.' &&
                    formikValues.Remarks !== 'Recordable indication observed hence not accepted.' &&
                    formikValues.Remarks !== 'Other' && (
                      <MenuItem value={formikValues.Remarks}>
                        {formikValues.Remarks}
                      </MenuItem>
                    )}
                </Select>
                {formikValues.Remarks === 'Other' && (
                  <TextField
                    name="customRemarks"
                    value={formikValues.customRemarks}
                    onChange={handleChange}
                    label="Custom Remark"
                    variant="outlined"
                    style={{ marginTop: '20px', width: '10vw' }}
                  />
                )}
              </FormControl>
              <Button onClick={handleAddRow} style={{ backgroundColor: "red", color: "white" }} variant="contained">Add</Button>


            </div>
            <div style={{ marginTop: "20px" }}>
              <DataGrid
                autoHeight
                density="compact"
                rows={rows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
              />
            </div>

          </div>
        </div>

      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "3vh" }}>
        {layoutPrintFormFields(ultrasonicPrintPairs.map((p) => p.left), []).map(renderUltrasonicPrintField)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "2rem", marginBottom: "2vh" }}>
        {layoutPrintFormFields([], ultrasonicPrintPairs.map((p) => p.right)).map(renderUltrasonicPrintField)}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "2rem", marginBottom: "8vh" }}>
        {/* <TextField fullWidth label="Technique (Pulse Echo)" name="Technique" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Technique} />
        <TextField fullWidth label="Gain" name="Gain" variant="outlined"
          error={formik.errors.Gain && formik.touched.Gain}
          helperText={formik.touched.Gain ? formik.errors.Gain : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Gain} />  */}
        <TextField fullWidth label="Witness By" name="Witness_By" variant="outlined"
          error={formik.errors.Witness_By && formik.touched.Witness_By}
          helperText={formik.touched.Witness_By ? formik.errors.Witness_By : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Witness_By} />
        <TextField fullWidth label="Technician" name="technician" variant="outlined"
          error={formik.errors.technician && formik.touched.technician}
          helperText={formik.touched.technician ? formik.errors.technician : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.technician} />
        <TextField fullWidth label="Designation" name="designation" variant="outlined"
          error={formik.errors.designation && formik.touched.designation}
          helperText={formik.touched.designation ? formik.errors.designation : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.designation} />
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", }}>
        <Button onClick={handlep} style={{ backgroundColor: latestId ? "orange" : "gray", color: "white", marginInline: "0.7rem", opacity: latestId ? 1 : 0.5 }} disabled={!latestId}>PRINT</Button>

        <Button
          onClick={formik.handleSubmit}
          style={{
            backgroundColor: "Green",
            color: "white",
            marginInline: "0.7rem",

          }}

        >
          {ultraId === undefined ? "Save" : "Update"}
        </Button>

        <Button onClick={handleBack} style={{ backgroundColor: "red", color: "white", marginInline: "0.7rem" }}>CANCEL</Button>
        <Button onClick={handleBack} style={{ backgroundColor: "blue", color: "white" }}>BACK</Button>
      </div>

      {/* Unpaid Bills Warning Dialog */}
      <Dialog
        open={unpaidDialogOpen}
        onClose={() => setUnpaidDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: '#d32f2f', color: '#fff' }}>
          ⚠️ Unpaid Bills Alert
        </DialogTitle>

        <div style={{ padding: '1rem' }}>
          <p style={{ color: '#d32f2f', fontWeight: 600, marginBottom: '1rem' }}>
            This customer has unpaid bills pending for more than 90 days.
            Please close these bills before creating a new transaction.
          </p>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: '#1976d2', color: '#fff' }}>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Bill No</th>
                <th style={thStyle}>Bill Date</th>
                <th style={thStyle}>Total (₹)</th>
                <th style={thStyle}>Received (₹)</th>
                <th style={thStyle}>Balance (₹)</th>
                <th style={thStyle}>Days Pending</th>
              </tr>
            </thead>
            <tbody>
              {unpaidBills.map((bill, i) => (
                <tr key={bill.id} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f5f5f5' }}>
                  <td style={tdStyle}>{i + 1}</td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{bill.Bill_no}</td>
                  <td style={tdStyle}>{bill.Bill_Date}</td>
                  <td style={tdStyle}>₹{Number(bill.GrandTotalAmt).toFixed(2)}</td>
                  <td style={tdStyle}>₹{Number(bill.received_amount).toFixed(2)}</td>
                  <td style={{ ...tdStyle, color: '#d32f2f', fontWeight: 700 }}>
                    ₹{Number(bill.balance).toFixed(2)}
                  </td>
                  <td style={{ ...tdStyle, color: '#d32f2f', fontWeight: 700 }}>
                    {bill.days_pending} days
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <DialogActions>
          <Button
            onClick={() => setUnpaidDialogOpen(false)}
            variant="contained"
            color="error"
          >
            OK, I Understand
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPDFModal}
        onClose={handlePDFModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

        maxWidth={1200}
      >
        <DialogTitle>
          Invoice
        </DialogTitle>

        <iframe title="pdf-view" src={pdfData && pdfData ? `${APP_BASE_PATH}${pdfData}` : null} width="800px" height="800px"></iframe>

        <DialogActions>
          <Button onClick={handlePDFModalClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={isConfirmationOpen}
        message={confirmationMessage}
        color={color}
        onClose={() => setIsConfirmationOpen(false)}
      />
    </div>

  )
}

export default CreateUltrasonic;
